module.exports = "<div class=\"container home-container\">\n  <div class=\"row header-row\">\n    <div class=\"col-lg-1\"></div>\n    <div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-10\">\n      <div class=\"wav-logo-container\">\n        <img class=\"img-fluid wav-logo\" src=\"https://firebasestorage.googleapis.com/v0/b/wav-studios.appspot.com/o/WAV_Studios%400.5x.png?alt=media&token=29a546f4-ba0e-4a20-819f-bb5719d6bb75\" alt=\"WAV Studios Logo\" (click)=\"navigateHome()\">\n      </div>\n    </div>\n    <div class=\"col-lg-1\"></div>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/header/header.component.html
// module id = SENk
// module chunks = 1